import { render } from "./HistoryArea.vue?vue&type=template&id=dbb0681a"
import script from "./HistoryArea.vue?vue&type=script&lang=js"
export * from "./HistoryArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__